module.exports = __webpack_public_path__ + "img/ep_present.878af1ca.svg";